/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Drastic_Tech_Stderr_LogInputs */

const en_drastic_tech_stderr_log = /** @type {(inputs: Drastic_Tech_Stderr_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC stderr]: ${i?.message}`)
};

const fr_drastic_tech_stderr_log = /** @type {(inputs: Drastic_Tech_Stderr_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC stderr] : ${i?.message}`)
};

const de_drastic_tech_stderr_log = /** @type {(inputs: Drastic_Tech_Stderr_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DROSTIC stderr]: ${i?.message}`)
};

const it_drastic_tech_stderr_log = /** @type {(inputs: Drastic_Tech_Stderr_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC stderr]: ${i?.message}`)
};

const ru_drastic_tech_stderr_log = /** @type {(inputs: Drastic_Tech_Stderr_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC stderr]: ${i?.message}`)
};

const es_drastic_tech_stderr_log = /** @type {(inputs: Drastic_Tech_Stderr_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[Error de salida DRÁSTICO]: ${i?.message}`)
};

const zh_cn2_drastic_tech_stderr_log = /** @type {(inputs: Drastic_Tech_Stderr_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC stderr]: ${i?.message}`)
};

const ja_drastic_tech_stderr_log = /** @type {(inputs: Drastic_Tech_Stderr_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[DRASTIC stderr]: ${i?.message}`)
};

const hi_drastic_tech_stderr_log = /** @type {(inputs: Drastic_Tech_Stderr_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[अत्यधिक गंभीर मानक त्रुटि]: ${i?.message}`)
};

const pt_pt2_drastic_tech_stderr_log = /** @type {(inputs: Drastic_Tech_Stderr_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[Deriva padrão DRASTIC]: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "[DRASTIC stderr]: {message}" |
*
* @param {Drastic_Tech_Stderr_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_stderr_log = /** @type {((inputs: Drastic_Tech_Stderr_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Stderr_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_stderr_log(inputs)
	if (locale === "de") return de_drastic_tech_stderr_log(inputs)
	if (locale === "it") return it_drastic_tech_stderr_log(inputs)
	if (locale === "ru") return ru_drastic_tech_stderr_log(inputs)
	if (locale === "es") return es_drastic_tech_stderr_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_stderr_log(inputs)
	if (locale === "ja") return ja_drastic_tech_stderr_log(inputs)
	if (locale === "hi") return hi_drastic_tech_stderr_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_stderr_log(inputs)
	return en_drastic_tech_stderr_log(inputs)
});